import dynamic from 'next/dynamic'

// Floating action button — pure interaction overlay with no SEO value, so
// skip SSR. Defers the chunk (and any transitively imported MUI / pixel
// code) until after the initial render.
const WhatsappButton = dynamic(() => import('./WhatsappButtonImpl'), {
  ssr: false
})

export default WhatsappButton
